import React from "react";
import { StarIcon, QuoteIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
import { testimonials } from "../../data/testimonials";
export function TestimonialsSection() {
  return <section className="w-full bg-white px-4 py-16 sm:px-5 sm:py-24" data-id="element-374" data-mp="1ruw798c5zhxv">
      <div className="mx-auto max-w-6xl" data-id="element-375" data-mp="1mwky6ztp1bgp">
        <p className="text-center text-sm font-bold uppercase tracking-widest text-wine" data-id="element-376" data-mp="1mvtdwl5jr05q">
          What dental professionals value most
        </p>
        <h2 className="mt-3 text-center font-serif text-[28px] font-black leading-tight text-navy sm:text-4xl" data-id="element-377" data-mp="1dvwk654avb3t">
          A More Organized Way to Study Early Orthodontic Decisions
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-378" data-mp="18ymvwssnd5hk">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-cream p-6" data-id="element-379" data-mp="33akvs452gp0s">
              <div className="flex items-center gap-4" data-id="element-380" data-mp="338gttrqqa035">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-white" data-id="element-381" data-mp="2yd1gr20jo87s" />
                <div className="min-w-0" data-id="element-382" data-mp="1y9hvs85vsjzz">
                  <p className="font-bold text-navy" data-id="element-383" data-mp="1y6dlct1tos0v">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-384" data-mp="1jd0l7j5in9eh">{t.role}</p>
                  <div className="mt-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-385" data-mp="1oa0s1wa6wg6n">
                    {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-386" data-mp="2c0my5i0mvqe0" />)}
                  </div>
                </div>
              </div>
              <QuoteIcon className="mt-5 h-7 w-7 text-wine" aria-hidden="true" data-id="element-387" data-mp="229jymkncrjgu" />
              <p className="mt-2 font-serif text-xl font-bold leading-snug text-navy" data-id="element-388" data-mp="278mubehg0dc5">“{t.headline}”</p>
              <blockquote className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-389" data-mp="2uyqzhqaa4l59">“{t.quote}”</blockquote>
              <figcaption className="mt-auto pt-5" data-id="element-390" data-mp="2zqr0zn5zzm3y">
                <span className="inline-block rounded-full bg-white px-3 py-1 text-xs font-bold uppercase tracking-wider text-wine" data-id="element-391" data-mp="2zrjydxj2gz9f">
                  {t.topic}
                </span>
              </figcaption>
            </figure>)}
        </div>

        <SectionCta label="I want this structured learning system" data-id="element-392" data-mp="30jon25jedv9c" />
      </div>
    </section>;
}